export default function mergeCssClasses( ...arr: any[]) {
	return arr.filter( i => typeof i === "string" ).join(" ");
}